/**
 * Labstep
 *
 * @module components/EntityView/Table
 * @desc EntityView Table
 */

import { EntityTableParamsContainer as EntityTable } from 'labstep-web/components/Entity/Table';
import { EntityViewActionMenu } from 'labstep-web/components/EntityView/Action/Menu';
import type React from 'react';
import type { EntityViewTableProps } from './types';

export const EntityViewTable: React.FC<EntityViewTableProps> = ({
  entityViews,
  actions,
  group,
}) => (
  <EntityTable
    id="entity-view-table"
    entities={entityViews}
    editableName
    actionMenu={({ entity }) => (
      <EntityViewActionMenu entityView={entity} actions={actions} />
    )}
    linkParams={(entity) => ({
      id: group.id,
      entityViewId: entity.id,
    })}
  />
);
